export type Row = [string, string];

export const transformationRows: Row[] = [
  [
    'You pray nobody mentions anything before class',
    'You ask about injuries first — because you know exactly what to do with the answer',
  ],
  ['Freeze, nod, panic-google at 8:58', 'Three questions, ninety seconds, a confident plan'],
  [
    'Water the whole class down "just in case"',
    'Precise adaptations for one body — the class stays strong for everyone else',
  ],
  ['"Who do you think you are?" on a loop', '"I know my next move" — quiet, grounded confidence'],
  [
    'Quietly avoiding pregnant, older and post-surgery clients',
    'The instructor people send their mother to',
  ],
  ['An instructor who teaches exercises', 'An instructor who teaches bodies'],
];

export const inactionRows: Row[] = [
  ['Watering classes down "just in case"', 'Bored regulars — and weaker word of mouth'],
  [
    'One client made to feel broken in front of the class',
    'She finds another studio — and tells the internet why',
  ],
  [
    'Improvising with injured bodies',
    'Legal exposure, in a world where lawyers bill $200–400/hour',
  ],
  [
    'Quietly turning away pregnant, older and post-op clients',
    'The fastest-growing client segments walk to the studio next door',
  ],
  ['Googling at 8:58 AM', 'Generic answers, zero scope, visible panic'],
];

export const closeRows: Row[] = [
  ['Freeze and improvise', 'Run a 90-second protocol'],
  ['Water it down for everyone', 'Adapt precisely for one body'],
  ['Fear the question', 'Welcome the question'],
];

export type FlowRow = {
  question: string;
  answer: string;
  output: string;
  tone: 'green' | 'amber' | 'red' | 'neutral';
};

export const flowchartRows: FlowRow[] = [
  {
    question: 'Q1. "Is this new, or ongoing?"',
    answer: 'New / acute / unassessed',
    output: 'RED — Refer before loading',
    tone: 'red',
  },
  {
    question: '',
    answer: 'Ongoing and managed',
    output: 'Continue to Q2',
    tone: 'neutral',
  },
  {
    question: 'Q2. "Has a doctor or physio seen it — any guidance?"',
    answer: 'Yes, with guidance',
    output: 'GREEN — Follow guidance exactly',
    tone: 'green',
  },
  {
    question: '',
    answer: 'No assessment / no guidance',
    output: 'YELLOW — Conservative defaults → Q3',
    tone: 'amber',
  },
  {
    question: 'Q3. "Does anything make it worse — or change with movement?"',
    answer: 'Worsening / radiating / nothing helps',
    output: 'RED — Flag, refer out',
    tone: 'red',
  },
  {
    question: '',
    answer: 'Predictable and mechanical',
    output: 'GREEN — Adapt and teach today',
    tone: 'green',
  },
];
